import React from 'react';
import { CONTACT_INFO } from '../constants/config';
import ContactLink from './ContactLink';
import '../styles/utilities.css';

const ContactInfo = () => {
  return (
    <div className="contact-info">
      <h2>Get In Touch</h2>

      <div className="contact-item">
        <h3>📞 Phone</h3>
        <p>
          <ContactLink type="phone" className="link-gold" />
          <br />
          <span className="contact-item-subtitle">Call Dave for a friendly chat</span>
        </p>
      </div>

      <div className="contact-item">
        <h3>📧 Email</h3>
        <p>
          <ContactLink type="email" className="link-gold" />
          <br />
        </p>
      </div>


      <div className="contact-item">
        <h3>⏰ Hours</h3>
        <p>
          Monday - Friday: {CONTACT_INFO.hours.weekday.open} - {CONTACT_INFO.hours.weekday.close}
          <br />
          Saturday - Sunday: {CONTACT_INFO.hours.weekend.open} - {CONTACT_INFO.hours.weekend.close}
        </p>
      </div>
    </div>
  );
};

export default ContactInfo;
